// NotificationsSheets.jsx — feuille « Options » (préférences) + Toast.
import React from "react";
import { Ico } from "./notificationsShared";

export function OptionsSheet({ open, onClose, sons, onToggleSons, onRefresh, onMute, onSettings }) {
  return (
    <div className={"sheet-host" + (open ? " open" : "")}>
      <div className="sheet-scrim" onClick={onClose} />
      <div className="sheet">
        <div className="sheet__grip" />
        <div className="sheet__b">
          <div className="sh-title">Préférences de notifications</div>
          <button className="opt" onClick={onToggleSons}>
            <span className="oico"><Ico name={sons ? "volume-2" : "volume-x"} /></span>
            <span className="opt__body">Sons<small>Alerte sonore à la réception</small></span>
            <span className={"mswitch" + (sons ? " on" : "")} />
          </button>
          <button className="opt" onClick={() => { onRefresh?.(); onClose(); }}>
            <span className="oico"><Ico name="rotate-cw" /></span>
            <span className="opt__body">Rafraîchir<small>Recharger les notifications</small></span>
          </button>
          <button className="opt" onClick={() => { onMute?.(); onClose(); }}>
            <span className="oico"><Ico name="eye-off" /></span>
            <span className="opt__body">Mettre en sourdine<small>Suspendre 24 h</small></span>
          </button>
          <button className="opt" onClick={() => { onSettings?.(); onClose(); }}>
            <span className="oico"><Ico name="settings" /></span>
            <span className="opt__body">Paramètres<small>Gérer les types et canaux</small></span>
          </button>
        </div>
      </div>
    </div>
  );
}

export function Toast({ data, onUndo }) {
  return (
    <div className={"toast" + (data ? " show" : "")}>
      {data && (
        <>
          <Ico name={data.ic || "check-circle-2"} />
          <span className="toast__msg">{data.msg}</span>
          {data.undo && <button className="toast__undo" onClick={onUndo}>Annuler</button>}
        </>
      )}
    </div>
  );
}
